



























import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace, State, Action } from 'vuex-class'
import { ActionMethod } from 'vuex'
import Page from './page.vue'
import ApplyForm from './apply-form.vue'
import SuccessDialog from './success-dialog.vue'
import { Cities } from '@/store'
import { Site, Page as PageType } from '@/store/freestyle'
import Catch from '@/plugins/catch'

const freestyle = namespace('freestyle')

@Component({
  components: {
    Page,
    ApplyForm,
    SuccessDialog
  }
})
export default class extends Vue {
  private showApply: boolean = false
  private showSuccess: boolean = false
  private submitting: boolean = false

  @Prop({
    type: String,
    required: true
  })
  url: string

  @freestyle.State
  config: Site

  @State
  cities?: Cities

  @freestyle.State
  sizes?: string[]

  @freestyle.Getter
  page: PageType

  @freestyle.State
  channel: string

  @freestyle.Mutation
  setChannel: ActionMethod

  @Action
  getCities: ActionMethod

  @freestyle.Action
  fetch: ActionMethod

  @freestyle.Action
  select: ActionMethod

  @freestyle.Action
  pick: ActionMethod

  @freestyle.Action
  deselect: ActionMethod

  @freestyle.Action
  submit: ActionMethod

  get $trackProps() {
    return {
      ItemCode: this.channel,
      ItemId: this.page && this.page.id
    }
  }

  @Catch
  async refresh() {
    const { channel } = this.$route.query
    if (channel) {
      await this.setChannel(channel)
    }

    if (!this.config) {
      await this.fetch(this.url)
    }
    const { title, stylesheet } = this.config
    if (title) {
      window.document.title = title
    }
    if (stylesheet) {
      const el = window.document.createElement('style')
      el.type = 'text/css'
      el.innerText = stylesheet
      window.document.getElementsByTagName('head')[0].appendChild(el)
    }
    const { id } = this.$route.params
    if (id) {
      try {
        await this.pick(id)
      } catch (error) {
        this.$router.replace({
          name: 'home',
          query: this.$route.query
        })
        throw new Error('页面不存在')
      }
    } else {
      await this.deselect()
    }
    this.$track('SPSH_PageLoaded')
    if (!this.cities) {
      await this.getCities()
    }
  }

  async beforeRouteEnter(to, from, next) {
    next(vm => vm.refresh())
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onEvent(name: string, args?: any[]) {
    switch (name) {
      case 'apply':
        this.onApply()
        break
    }
  }

  onNavigate(id: string, replace?: boolean) {
    const { pages, index } = this.config
    if (pages && index != null && pages[index] && pages[index].id === id) {
      this.$router[replace ? 'replace' : 'push']({
        name: 'home',
        query: this.$route.query
      })
    } else {
      this.$track({
        ElementId: 'SPSH_ShowDetail',
        ItemId: id
      })
      this.$router[replace ? 'replace' : 'push']({
        name: 'page',
        params: { id },
        query: this.$route.query
      })
    }
  }

  onApply() {
    this.showApply = true
    this.$track('SPSH_ContestApply')
  }

  async onSubmit(data: any) {
    this.submitting = true
    this.$track('SPSH_ContestSubmit')
    try {
      await this.submit(data)
    } catch (error) {
      this.$notify('提交失败 请重试')
      return
    } finally {
      this.submitting = false
    }
    this.onApplySuccess()
  }

  onApplySuccess() {
    this.showApply = false
    this.showSuccess = true
    this.$track('SPSH_ContestApplied')
  }
}
